import { useState } from "react";
import { toast } from "sonner";
import { updateMe, CLUB_BASE } from "./clubApi";
import { Btn, Card, Field, inputCls } from "./ui";
import MyTemplates from "./MyTemplates";

export default function TeamSettings({ user, onUser }) {
  const [f, setF] = useState({ name: user.name || "", whatsapp: user.whatsapp || "", forever_link: user.forever_link || "", slug: user.slug || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const u = await updateMe(f); onUser(u); toast.success("Profilo salvato"); } catch (e) { toast.error(e?.response?.data?.detail || "Errore nel salvataggio"); }
    setBusy(false);
  };
  return (
    <>
    <Card className="mt-6 space-y-5" data-testid="team-settings">
      <Field label="Nome che vede il cliente"><input className={inputCls} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="settings-name" /></Field>
      <Field label="Il tuo WhatsApp" hint="Con prefisso, es. 393331234567. Il cliente ti scrive da qui."><input className={inputCls} value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} inputMode="tel" data-testid="settings-whatsapp" /></Field>
      <Field label="Il tuo link negozio Forever" hint="Il link personale del tuo shop: compare nel percorso del cliente come «Ordina»."><input className={inputCls} value={f.forever_link} onChange={(e) => setF({ ...f, forever_link: e.target.value })} placeholder="https://..." data-testid="settings-forever-link" /></Field>
      <Field label="Il tuo link test" hint={`${window.location.origin}${CLUB_BASE}/i/${f.slug || "…"}`}><input className={inputCls} value={f.slug} onChange={(e) => setF({ ...f, slug: e.target.value })} data-testid="settings-slug" /></Field>
      <Btn onClick={save} disabled={busy} data-testid="settings-save">{busy ? "Salvo…" : "Salva"}</Btn>
    </Card>
    <MyTemplates />
    </>
  );
}
